const maximizeYourExperienceEndpoints = {
  base: "/v1/cms/maximaze-your-experience",
  byTour: (tourId) =>
    `/v1/cms/maximaze-your-experience/${encodeURIComponent(
      String(tourId || ""),
    )}`,
};

export default maximizeYourExperienceEndpoints;
